import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import objectSupport from 'dayjs/plugin/objectSupport';
import relativeTime from 'dayjs/plugin/relativeTime';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import duration from 'dayjs/plugin/duration';
import updateLocale from 'dayjs/plugin/updateLocale';
import isBetween from 'dayjs/plugin/isBetween';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import timezone from 'dayjs/plugin/timezone';

export default defineNuxtPlugin({
  name: 'dayjs',
  parallel: true,
  dependsOn: ['locale'],
  setup() {
    const { $t } = useNuxtApp();
    const threshold = [
      { l: 's', r: 1 },
      { l: 'm', r: 1 },
      { l: 'mm', r: 59, d: 'minute' },
      { l: 'h', r: 1 },
      { l: 'hh', r: 48, d: 'hour' },
      { l: 'd', r: 1 },
      { l: 'dd', r: 29, d: 'day' },
      { l: 'M', r: 1 },
      { l: 'MM', r: 11, d: 'month' },
      { l: 'y', r: 1 },
      { l: 'yy', d: 'year' },
    ];

    dayjs.extend(utc);
    dayjs.extend(objectSupport);
    dayjs.extend(relativeTime, {
      thresholds: threshold,
    });
    dayjs.extend(isSameOrAfter);
    dayjs.extend(updateLocale);
    dayjs.extend(duration);
    dayjs.extend(isBetween);
    dayjs.extend(customParseFormat);
    dayjs.extend(localizedFormat);
    dayjs.extend(isSameOrBefore);
    dayjs.extend(isSameOrAfter);
    dayjs.extend(timezone);

    dayjs.updateLocale('en', {
      relativeTime: {
        future: `%s ${$t('left')}`,
        past: `%s ${$t('ago')}`,
        s: `${$t('seconds')}`,
        m: `1 ${$t('minute')}`,
        mm: `%d ${$t('minutes')}`,
        h: `1 ${$t('hour')}`,
        hh: `%d ${$t('hours')}`,
        d: `1 ${$t('day')}`,
        dd: `%d ${$t('days')}`,
        M: `1 ${$t('month')}`,
        MM: `%d ${$t('months')}`,
        y: `1 ${$t('year')}`,
        yy: `%d ${$t('years')}`,
      },
    });

    return {
      provide: {
        dayjs,
      },
    };
  },
});
